import { Action, createReducer, on } from '@ngrx/store';
import { ClearUserAction } from 'src/app/auth/store/auth.actions';
import {
    SetProfileAction,
    SetUserScopesAction,
    SetUserRecordAction,
    SetUserRecordSecEmailStateAction,
    SetUserSearchActiveForm,
    SetUserSearchAdvancedForm,
    SetUserSearchPageOptionsAction,
    SetUserSearchQuickFilters,
    SetUserSearchQuickForm,
    SetUserSearchTotalAction,
    SetUserSearchUsersAction,
} from './user.actions';

import { UserState } from '../user.model';
import { initialState } from './user.state';

const reducer = createReducer(
    initialState,
    on(ClearUserAction, (_state: UserState) => ({ ...initialState })),
    on(SetProfileAction, (state: UserState, { profile }) => ({
        ...state,
        profile: {
            ...state.profile,
            id: profile._id,
            firstName: profile.firstName,
            lastName: profile.lastName,
            picture: profile.picture,
            email: profile.email,
            secEmail: profile.secEmail,
            phone: profile.phone,
            sex: profile.sex,
            secPhone: profile.secPhone,
            secPhoneExt: profile.secPhoneExt,
            preferences: profile.preferences,
            cellPhone: profile.cellPhone,
            birthDate: profile.birthDate,
            addresses: [...(profile.addresses || [])],
            linkedAccounts: profile.linkedAccounts,
        },
    })),
    on(SetUserRecordAction, (state: UserState, { userRecord }) => ({
        ...state,
        userRecord: {
            ...state.userRecord,
            id: userRecord.id,
            firstName: userRecord.firstName,
            lastName: userRecord.lastName,
            picture: userRecord.picture,
            email: userRecord.email,
            secEmail: userRecord.secEmail,
            phone: userRecord.phone,
            sex: userRecord.sex,
            secPhone: userRecord.secPhone,
            secPhoneExt: userRecord.secPhoneExt,
            cellPhone: userRecord.cellPhone,
            birthDate: userRecord.birthDate,
            addresses: [...(userRecord.addresses || [])],
            unregistered: userRecord.unregistered,
        },
    })),
    on(SetUserSearchUsersAction, (state: UserState, { users }) => ({
        ...state,
        userSearch: { ...state.userSearch, users: !users?.length ? [] : [...users] },
    })),
    on(SetUserSearchTotalAction, (state: UserState, { total }) => ({
        ...state,
        userSearch: { ...state.userSearch, total },
    })),
    on(SetUserSearchPageOptionsAction, (state: UserState, { pageIndex, itemsPerPage }) => ({
        ...state,
        userSearch: {
            ...state.userSearch,
            pageIndex,
            itemsPerPage,
        },
    })),
    on(SetUserSearchQuickForm, (state: UserState, { quickSearchForm }) => ({
        ...state,
        userSearch: {
            ...state.userSearch,
            quickSearchForm: {
                ...quickSearchForm,
            },
        },
    })),
    on(SetUserSearchAdvancedForm, (state: UserState, { advancedSearchForm }) => ({
        ...state,
        userSearch: {
            ...state.userSearch,
            advancedSearchForm: {
                ...advancedSearchForm,
            },
        },
    })),
    on(SetUserSearchActiveForm, (state: UserState, { activeForm }) => ({
        ...state,
        userSearch: {
            ...state.userSearch,
            activeForm,
        },
    })),
    on(SetUserSearchQuickFilters, (state: UserState, { cardsToApproveActive, familyLinksToApproveActive, residencesToApproveActive, moreFiltersData }) => ({
        ...state,
        userSearch: {
            ...state.userSearch,
            quickFilters: {
                cardsToApproveActive,
                familyLinksToApproveActive,
                residencesToApproveActive,
                moreFiltersData,
            },
        },
    })),
    on(SetUserScopesAction, (state: UserState, { scopes }) => ({
        ...state,
        scopes: scopes.map((scope) => ({
            permission: scope.p,
            resource: scope.r,
            resourceId: scope.i,
            accessLevel: scope.a === 'w' ? 'write' : 'read',
        })),
    })),
    on(SetUserRecordSecEmailStateAction, (state: UserState, { userRecordSecEmailStatePayload }) => ({
        ...state,
        userRecordEmailChangedState: {
            ...state.userRecordEmailChangedState,
            ...userRecordSecEmailStatePayload,
        },
    })),
);
export function UserReducer(state: UserState, action: Action): UserState {
    return reducer(state, action);
}
